module.exports = __webpack_public_path__ + "static/media/headshot.cbc56153.jpg";